import React from "react";

class SystemError extends React.Component {
  render() {
    return (
      <div data-testid="system-error">
        We're sorry! Something went wrong. Please try again shortly.
      </div>
    );
  }
}

export default SystemError;
